/*LIBRARY*/
import { connect } from "react-redux";

/*COMPONENT*/

/*REDUX*/

/*PICTURE*/

/*FUNCTION*/
import format_date_short from "../../App/validation/format_date_short";
import {
  count_day_left,
  format_duration,
} from "../../App/validation/count_day_left";
import { payment_type_to_name_of_license } from "../../App/validation/license_helper";

/*DATA*/

/*CONST*/

const LICENSE_DETAIL = ({ auth, license_reducer }) => {
  //local storage
  const language = localStorage?.language || auth?.language;

  //local state

  //global props
  const { map_access, max_quota } = auth;
  const {
    license_basic,
    license_sini_ai,
    license_sini_data,
    license_sharing,
    license_user_status,
    license_group_status,
  } = license_reducer;

  let active_individual_license = {};
  if (license_basic?.is_has_license) active_individual_license = license_basic;
  else if (license_user_status) active_individual_license = license_user_status;

  let active_sharing_license = {};
  if (license_sharing?.is_has_license) active_sharing_license = license_sharing;
  else if (license_group_status) active_sharing_license = license_group_status;

  //content
  let delta_access = max_quota - map_access;
  if (delta_access < 0) {
    delta_access = 0;
  }

  const date_now = new Date();
  const sini_ai_date = format_duration(
    count_day_left(date_now, new Date(license_sini_ai?.date_finish)),
    language
  );
  const sini_data_date = format_duration(
    count_day_left(date_now, new Date(license_sini_data?.date_finish)),
    language
  );

  return (
    <div>
      <div
        className="detail_profile_wrapper"
        style={{
          display: "flex",

          gap: "10px",
        }}
      >
        {active_individual_license.is_has_license && (
          <section
            className="container_project background_white outline_grey"
            style={{
              verticalAlign: "top",
              display: "flex",
              flexDirection: "column",
              flex: "none",
            }}
          >
            <p className="text_medium sub_color">Lisensi user</p>
            <p className="text_bold margin_bottom_extra">
              {payment_type_to_name_of_license(
                active_individual_license?.payment_type,
                language
              )}
            </p>
            {license_sini_ai?.is_has_license && (
              <div>
                <span className="text_bold">SINI AI</span>{" "}
                <span className="text_medium sub_color">({sini_ai_date})</span>
              </div>
            )}
            {license_sini_data?.is_has_license && (
              <div>
                <span className="text_bold">SINI DATA</span>{" "}
                <span className="text_medium sub_color">
                  ({sini_data_date})
                </span>
              </div>
            )}

            <p
              className="badge blue_container"
              id="footer_part"
              style={{ marginTop: "auto", width: "fit-content" }}
            >
              Active until{" "}
              {format_date_short(active_individual_license?.date_finish)}
            </p>
          </section>
        )}
        {active_sharing_license.is_has_license && (
          <section
            className="container_project background_white outline_grey"
            style={{
              verticalAlign: "top",
              display: "flex",
              flexDirection: "column",
              flex: "none",
            }}
          >
            <p className="text_medium sub_color">Lisensi sharing</p>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "start",
                }}
              >
                <p className="text_bold">
                  {payment_type_to_name_of_license(
                    active_sharing_license?.payment_type,
                    language
                  )}
                </p>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "end",
                }}
              >
                <p className="text_small">{`Supported by:`}</p>
                <p className="badge grey_container">
                  {active_sharing_license?.user?.full_name ||
                    active_sharing_license?.user?.name}
                </p>
              </div>
            </div>
            <p
              className="badge blue_container"
              id="footer_part"
              style={{ marginTop: "auto", width: "fit-content" }}
            >
              Active until{" "}
              {format_date_short(active_sharing_license?.date_finish)}
            </p>
          </section>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  payment: state.payment,
  properties: state.properties,
  license_reducer: state.license_reducer,
});

export default connect(mapStateToProps, {})(LICENSE_DETAIL);
